import React from "react";
import { newLogo } from "../../assets/Images";

const listItems = [
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  }
];

export default function MoreFromUsNews() {
  return (
    <section className="w-full py-16 px-6 bg-transparent text-white">
      <div className="max-w-6xl mx-auto text-left">
        {/* Section Title */}
        <h2 className="text-2xl sm:text-3xl font-bold font-oswald tracking-widest uppercase mb-10 border-b border-neutral-900 pb-4">
          MORE FROM US
        </h2>

        {/* List Container */}
        <div className="flex flex-col gap-6">
          {listItems.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col sm:flex-row items-stretch gap-6 p-5 bg-[#111]/60 backdrop-blur-sm border border-neutral-900 rounded-xl hover:border-secondary transition-all duration-350 group"
            >
              {/* Thumbnail (Left) */}
              <div className="w-full sm:w-48 aspect-[16/10] bg-black rounded-lg border border-neutral-800 flex flex-col items-center justify-center p-4 group-hover:border-secondary/40 transition-colors flex-shrink-0">
                <img
                  src={newLogo}
                  alt="BAB Logo"
                  className="object-contain h-12 w-auto mb-1.5 drop-shadow-[0_3px_6px_rgba(255,140,33,0.15)]"
                />
                <span className="text-secondary font-oswald text-[10px] tracking-[0.2em] font-bold uppercase">
                  Coming Soon
                </span>
              </div>

              {/* Text & Content (Right) */}
              <div className="flex flex-col justify-center text-left">
                {/* Title */}
                <h3 className="text-lg md:text-xl font-bold font-oswald text-secondary group-hover:text-white transition-colors duration-300 tracking-wide uppercase mb-2 flex items-center gap-1.5">
                  {item.title}
                  <svg className="w-4 h-4 transform group-hover:translate-x-1.5 transition-transform duration-300 text-secondary group-hover:text-white" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                  </svg>
                </h3>

                {/* Description */}
                <p className="text-neutral-400 font-outfit text-sm leading-relaxed max-w-2xl">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
